import React, { Component } from "react";
import injectSectionElements from "../injectSectionElements";

class RepeatedItem extends Component {
  render() {
    const {
      Component: ItemComponent,
      values,
      Elements,
      number,
      classes,
    } = this.props;
    return (
      <ItemComponent
        classes={classes}
        number={number}
        Elements={Elements}
        {...values}
      />
    );
  }
}

const RepeatedItemWithElements = injectSectionElements(RepeatedItem);

const RepeatedItems = ({ classes, Component: ItemComponent, value }) =>
  value.map((current, index) => (
    <RepeatedItemWithElements
      key={index}
      number={index + 1}
      Component={ItemComponent}
      values={current}
      classes={classes}
    />
  ));

export default RepeatedItems;
